import { render, staticRenderFns } from "./editReward.vue?vue&type=template&id=8596a148&scoped=true&"
import script from "./editReward.vue?vue&type=script&lang=js&"
export * from "./editReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8596a148",
  null
  
)

export default component.exports